import {
  LanguageInfo,
  MessengerGeneralSetting,
  OrganizationChartGeneralSetting,
  OrganizationChartSetting,
  OrganizationGeneralSetting,
  OrganizationProfileSetting,
  SecurityEnv,
  SystemChannelCommandsSetting,
  TenantCommonPreviewSetting,
  TenantGeneralSetting,
  TranslatorSettingWrapper,
} from '@@types/Api/Setting';
import { ORG_ID } from '@@types/common';
import { account } from '@dooray/api-client';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';

class SettingApi {
  constructor(private api: Api2) {}

  fetchOrganizationChartSetting = (): Promise<OrganizationChartSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/organization-chart`);
  };

  fetchOrganizationChartGeneralSetting = (): Promise<OrganizationChartGeneralSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/organization-chart.general`);
  };

  fetchSystemCommands = (): Promise<SystemChannelCommandsSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/system-channel-commands`);
  };

  fetchMessengerGeneralSetting = (): Promise<MessengerGeneralSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/messenger.general`);
  };

  fetchLanguages = (): Promise<LanguageInfo[]> => {
    return this.api.contentsRequester.get(`${URLS.API}/translate/supportlanguages`);
  };

  fetchTenantGeneralSetting = (): Promise<TenantGeneralSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/general`);
  };

  fetchTenantCommonPreviewSetting = (): Promise<TenantCommonPreviewSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/common.preview`);
  };

  fetchGuestOrganizationGeneralSetting = (): Promise<OrganizationGeneralSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/organizations/GUEST/settings/general`);
  };

  fetchOrganizationProfileSetting = (orgId: ORG_ID): Promise<OrganizationProfileSetting> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/organizations/!${orgId}/settings/personal.profile`);
  };

  fetchTranslatorSetting = (): Promise<TranslatorSettingWrapper> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/settings/translator`);
  };

  fetchSecurityEnv = (): Promise<SecurityEnv> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/security-env`);
  };

  fetchAvailableProductItems = (): Promise<account.AvailableProductItem[]> => {
    return this.api.resultRequester.post(`${URLS.ACCOUNT_API}/members/me/fetch-available-product-items`);
  };

  updateStreamPush = (useStreamChannel: boolean): Promise<void> => {
    return this.api.contentsRequester.put(`${URLS.PROJECT_API}/members/settings/stream.push`, { useStreamChannel });
  };
}

export default SettingApi;
